import "../Home/projectPage2.css"
import Line from "../../img/line.png"
import CatbotVideo from "../../img/Catbot/Spatial-CatbotConvo.mp4"
import CatbotScreenshot from "../../img/Catbot/CatbotConvoScreenshot.png"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from "react";
import Slider from "react-slick";
import CardImage from "../Home/CardImage";
import CardVideo from "../Home/CardVideo";


export const Catbot = () =>
{
    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        slickPlay: true
    };

    return (
        <div className="pp2">
            <div className="pp2-grid-container">
                <div className="pp2-grid-item-col">
                    <h1 className="pp2-title">catbot
                        <img src={Line} alt="" className="pp2-title-line"></img>
                    </h1>
                </div>
                <div className="pp2-grid-item-row summary-align">
                    <p className="pp2-summary">A chatbot created for the Spatial platform to introduce new users to some of the platform's features</p>
                </div>
            </div>
           
            {/* Carousel */}
            <Slider {...settings}>
                <CardVideo source={CatbotVideo} type="video/mp4" />
            </Slider>

            <div className="pp2-grid-container">
                <div className="pp2-grid-item-row section-separator">
                    <div className="pp2-subtitle">overview</div>
                    <p className="pp2-description">
                    Catbot is a chatbot created in Unity for the Spatial platform using Spatial Creator Toolkit. The "catbot", a robot cat explains different aspects of the Spatial environment and answers questions from the user. The catbot was created by a team of two developers.
                    </p>
                    <br />
                    <p className="pp2-role">Primary responsibilities: Game development, Game design.</p>
                
                </div>

                <div className="pp2-grid-item-row section-separator tags-grid">
                    <div className="pp2-subtitle">tools</div>

                    <div className="pp2-grid-container-five-col">
                        <div className="pp2-grid-item-col"><div className="tag">UNITY</div></div>
                        <div className="pp2-grid-item-col"><div className="tag">VISUAL SCRIPTING</div></div>
                        <div className="pp2-grid-item-col"><div className="tag">SPATIAL TOOLKIT</div></div>
                        <div className="pp2-grid-item-col"><div className="tag">GITHUB</div></div>
                    </div>
                </div>

                {/* C1R7 - Back */}
                <div class="pp2-grid-item-row back">
                    <div className="pp2-subtitle">
                    <a href="/" target="_self" className="pp2-back">back
                        <img src={Line} alt="" className="pp2-back-line"></img>
                    </a>
                    </div>
                </div>
            </div>
        </div>
    )
};